<template>
  <div class="extra-games">
    <div class="extra-game-box">
      <div class="main-game">
        <div class="betting-holder-title">
          <h2>
            <span data-langname="all_of_the_balls">All Of The Balls</span>
          </h2>
        </div>
        <div class="body extras-body">
          <ul class="small-bet-balls">
            <li
              v-for="(ball, index) in topColors"
              :class="
                ball.selected
                  ? ball.color +
                    '-balls top-color bhr-balls bhr-balls-choosen bhr-balls-choosen-' +
                    ball.color
                  : ball.color + '-balls top-color bhr-balls'
              "
              :data-color="ball.color"
              :key="index"
              @click="setTopColor(ball)"
            >
              <a href></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="sub-games">
        <div class="left">
          <div class="betting-holder-title">
            <h3>
              <span data-langname="odd_even"></span>
            </h3>
          </div>
          <div class="buttons">
            <button
              id="more-even"
              data-langname="even"
              @click="setBallParity(1)"
              :class="ballParity == 1 ? 'betting-btn-chosen' : ''"
            ></button>
            <button
              id="more-odd"
              data-langname="odd"
              @click="setBallParity(2)"
              :class="ballParity == 2 ? 'betting-btn-chosen' : ''"
            ></button>
          </div>
        </div>
        <div class="right">
          <div class="betting-holder-title">
            <h3>
              <span data-langname="first_five_balls"></span>
            </h3>
          </div>
          <div class="buttons">
            <button
              id="first5lessthan122"
              data-langname="less"
              @click="setFirstFiveSum(1)"
              :class="firstFiveSum == 1 ? 'betting-btn-chosen' : ''"
            ></button>
            <button
              id="first5morethan122"
              data-langname="more"
              @click="setFirstFiveSum(2)"
              :class="firstFiveSum == 2 ? 'betting-btn-chosen' : ''"
            ></button>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div class="extra-game-box">
      <div class="main-game">
        <div class="betting-holder-title">
          <h2>
            <span data-langname="first_ball">Sum First 5</span>
          </h2>
        </div>
        <div class="body extras-body">
          <ul class="small-bet-balls">
            <li
              v-for="(ball, index) in firstColors"
              :class="
                ball.selected
                  ? ball.color +
                    '-balls first-ball-color bhr-balls bhr-balls-choosen bhr-balls-choosen-' +
                    ball.color
                  : ball.color + '-balls first-ball-color bhr-balls'
              "
              :data-color="ball.color"
              :key="index"
              @click="setFirstColor(ball)"
            >
              <a href></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="sub-games">
        <div class="left">
          <div class="betting-holder-title">
            <h3>
              <span data-langname="odd_even"></span>
            </h3>
          </div>
          <div class="buttons">
            <button
              id="firstballeven"
              data-langname="even"
              @click="setFirstBallParity(1)"
              :class="firstBallParity == 1 ? 'betting-btn-chosen' : ''"
            ></button>
            <button
              id="firstballodd"
              data-langname="odd"
              @click="setFirstBallParity(2)"
              :class="firstBallParity == 2 ? 'betting-btn-chosen' : ''"
            ></button>
          </div>
        </div>
        <div class="right">
          <div class="betting-holder-title">
            <h3>
              <span> <span data-langname="value"></span> (24.5) </span>
            </h3>
          </div>
          <div class="buttons">
            <button
              id="firstballlessthan24"
              data-langname="less"
              @click="setFirstBallSum(1)"
              :class="firstBallSum == 1 ? 'betting-btn-chosen' : ''"
            >
              LESS
            </button>
            <button
              id="firstballmorethan24"
              data-langname="more"
              @click="setFirstBallSum(2)"
              :class="firstBallSum == 2 ? 'betting-btn-chosen' : ''"
            >
              MORE
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div class="extra-game-box">
      <div class="main-game">
        <div class="betting-holder-title">
          <h2>
            <span data-langname="last_ball">Last Ball</span>
          </h2>
        </div>
        <div class="body extras-body">
          <ul class="small-bet-balls">
            <li
              v-for="(ball, index) in lastColors"
              :class="
                ball.selected
                  ? ball.color +
                    '-balls last-ball-color bhr-balls bhr-balls-choosen bhr-balls-choosen-' +
                    ball.color
                  : ball.color + '-balls last-ball-color bhr-balls'
              "
              :data-color="ball.color"
              :key="index"
              @click="setLastColor(ball)"
            >
              <a href></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="sub-games">
        <div class="left">
          <div class="betting-holder-title">
            <h3>
              <span data-langname="odd_even"></span>
            </h3>
          </div>

          <div class="buttons">
            <button
              id="lastballeven"
              data-langname="even"
              @click="setLastBallParity(1)"
              :class="lastBallParity == 1 ? 'betting-btn-chosen' : ''"
            >
              EVEN
            </button>
            <button
              id="lastballodd"
              data-langname="odd"
              @click="setLastBallParity(2)"
              :class="lastBallParity == 2 ? 'betting-btn-chosen' : ''"
            >
              ODD
            </button>
          </div>
        </div>
        <div class="right">
          <div class="betting-holder-title">
            <h3>
              <span> <span data-langname="value"></span> (24.5) </span>
            </h3>
          </div>
          <div class="buttons">
            <button
              id="lastballlessthan24"
              data-langname="less"
              @click="setLastBallSum(1)"
              :class="lastBallSum == 1 ? 'betting-btn-chosen' : ''"
            >
              LESS
            </button>
            <button
              id="lastballmorethan24"
              data-langname="more"
              @click="setLastBallSum(2)"
              :class="lastBallSum == 2 ? 'betting-btn-chosen' : ''"
            >
              MORE
            </button>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import $eventBus from "../../eventBus";
import { translate } from "../../assets/common/lang";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      topColors: [],
      firstColors: [],
      lastColors: [],
      ballParity: 0,
      firstFiveSum: 0,
      firstBallParity: 0,
      lastBallParity: 0,
      firstBallSum: 0,
      lastBallSum: 0,
      colors: {
        red: 1,
        green: 2,
        blue: 3,
        purple: 4,
        brown: 5,
        yellow: 6,
        orange: 7,
        silver: 8,
      },
      maxSlipLength: 17
    };
  },
  computed: {
     ...mapGetters(["getSlip", "getGameConfig"])
  },
  methods: {
    translate(word) {
      return translate(word);
    },
    setTopColor(ball) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.topColors.filter((color) => color.selected).length > 0) {
          this.topColors.map((loopBall) => {
            if (ball.color == loopBall.color) {
              loopBall.selected = !loopBall.selected;
              if (this.topColors.filter((color) => color.selected).length > 4) {
                this.$bvToast.toast(
                    translate('choose_1_2_4_common'),
                  {
                    title: translate("notification"),
                    variant: "danger",
                    autoHideDelay: 3000,
                    toaster: "b-toaster-top-center",
                  }
                );
                loopBall.selected = false;
            }
              if (this.topColors.filter((color) => color.selected).length < 1) {
                this.$emit("removeFromSlip", "TC");
                this.sendNoOfCombs();
              }
            }
          })
        } else {
          if (!this.isSlipFull()) {
            this.topColors = this.topColors.map((loopBall) => {
              if (ball.color == loopBall.color) {
                loopBall.selected = !loopBall.selected;
              }
              return loopBall;
            });
            this.sendNoOfCombs();
            if (this.topColors.filter((color) => color.selected).length > 4) {
              this.$bvToast.toast(
                  translate('choose_1_2_4_common'),
                {
                  title: translate("notification"),
                  variant: "danger",
                  autoHideDelay: 3000,
                  toaster: "b-toaster-top-center",
                }
              );
            }

            if (this.topColors.filter((color) => color.selected).length < 1) {
              this.$emit("removeFromSlip", "TC");
            }
            if (this.topColors.filter((color) => color.selected).length > 0) {
              this.addToSlipTopBalls();
            }
          } 
        }
    },
    isSlipFull() {
      if (this.getSlip.length >= this.maxSlipLength) {
        this.$bvToast.toast(translate("max_no_of_items_reached"), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 500,
          toaster: "b-toaster-top-center",
        });
        return true;
      }

      return false;
    },
    checkAreAlreadyBallsInSlip() {
      if (this.getSlip.length) {
        if (this.getSlip.filter(i => i.type === "BALLS").length > 1) {
          // this.$bvToast.toast("CANNOT PLAY EXTRA GAMES MORE THAN 1 HAND COMBINATION CHOSEN"), {
          //   title: translate("notification"),
          //   variant: "danger",
          //   autoHideDelay: 500,
          //   toaster: "b-toaster-top-center"
          // }
          return true;
        }  
      }
    },      
    addToSlipTopBalls() {
      this.$emit("addToSlip", {
        type: "EXTRAS-COLORS",
        name: translate("top_color"),
        id: "TC",
        value: this.topColors,
        minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
      });
    },
    addToSlipFirstBalls() {
      this.$emit("addToSlip", {
        type: "EXTRAS-COLORS",
        name: translate("first_color"),
        id: "FVC",
        value: this.firstColors,
        minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
      });
    },
     addToSlipLastBalls() {
      this.$emit("addToSlip", {
        type: "EXTRAS-COLORS",
        name: translate("last_color"),
        id: "LBC",
        value: this.lastColors,
        minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
      });
    },
    clearAllBets() {
      this.topColors = this.topColors.map((loopBall) => {
        loopBall.selected = false;
        return loopBall;
      });
      this.firstColors = this.firstColors.map((loopBall) => {
        loopBall.selected = false;
        return loopBall;
      });
      this.lastColors = this.lastColors.map((loopBall) => {
        loopBall.selected = false;
        return loopBall;
      });
      this.ballParity = 0;
      this.firstFiveSum = 0;
      this.firstBallParity = 0;
      this.lastBallParity = 0;
      this.firstBallSum = 0;
      this.lastBallSum = 0;
      this.sendNoOfCombs();
    },
    sendNoOfCombs() {
      let noOfCombs = 0;
      if (this.firstFiveSum != 0) {
        noOfCombs++;
      }
      if (this.ballParity != 0) {
        noOfCombs++;
      }
      if (this.lastBallSum != 0) {
        noOfCombs++;
      }
      if (this.firstBallParity != 0) {
        noOfCombs++;
      }
      if (this.lastBallParity != 0) {
        noOfCombs++;
      }
      if (this.firstBallSum != 0) {
        noOfCombs++;
      }
      if (this.topColors.filter((color) => color.selected).length) {
        noOfCombs++;
      }
      if (this.firstColors.filter((color) => color.selected).length) {
        noOfCombs++;
      }
      if (this.lastColors.filter((color) => color.selected).length) {
        noOfCombs++;
      }
      this.$emit("setExtraCombinations", noOfCombs);
    },
    setLastBallParity(number) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.lastBallParity !== 0) {
        if (this.lastBallParity == number) {
          this.lastBallParity = 0;
          this.$emit("removeFromSlip", "LBP");
        } else {
          this.$emit("removeFromSlip", "LBP");
          this.lastBallParity = number;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('last_ball'),
            id: "LBP",
            value: Number(number) === 1 ? translate("even") : translate("odd"),
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.lastBallParity == number) {
            this.lastBallParity = 0;
            this.$emit("removeFromSlip", "LBP");
          } else {
            this.lastBallParity = number;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate('last_ball'),
              id: "LBP",
              value: Number(number) === 1 ? translate("even") : translate("odd"),
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
            });
          }
          this.sendNoOfCombs();
          }
      }
    },
    setFirstBallParity(number) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.firstBallParity !== 0) {
        if (this.firstBallParity == number) {
          this.firstBallParity = 0;
          this.$emit("removeFromSlip", "FBP");
        } else {
          this.$emit("removeFromSlip", "FBP");
          this.firstBallParity = number;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('first_ball'),
            id: "FBP",
            value: Number(number) === 1 ? translate("even") : translate("odd"),
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.firstBallParity == number) {
            this.firstBallParity = 0;
            this.$emit("removeFromSlip", "FBP");
          } else {
            this.firstBallParity = number;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate("first_ball"),
              id: "FBP",
              value: Number(number) === 1 ? translate("even") : translate("odd"),
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
        }
      }
    },
    setBallParity(number) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.ballParity !== 0) {
        if (this.ballParity == number) {
          this.ballParity = 0;
          this.$emit("removeFromSlip", "BP");
        } else {
          this.$emit("removeFromSlip", "BP");
          this.ballParity = number;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('all_of_the_balls'),
            id: "BP",
            value: Number(number) === 1 ? translate("even") : translate("odd"),
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.ballParity == number) {
            this.ballParity = 0;
            this.$emit("removeFromSlip", "BP");
          } else {
            this.ballParity = number;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate("all_of_the_balls"),
              id: "BP",
              value: Number(number) === 1 ? translate("even") : translate("odd"),
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
            });
          }
          this.sendNoOfCombs();
        }
      }
    },
    setLastBallSum(choice) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.lastBallSum !== 0) {
        if (this.lastBallSum == choice) {
          this.lastBallSum = 0;
          this.$emit("removeFromSlip", "LBS");
        } else {
          this.$emit("removeFromSlip", "LBS");
          this.lastBallSum = choice;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('last_ball'),
            id: "LBS",
            value: Number(choice) === 1 ? translate("sum_less_than") + "24.5" : translate("sum_more_than")  + "24.5",
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.lastBallSum == choice) {
            this.lastBallSum = 0;
            this.$emit("removeFromSlip", "LBS");
          } else {
            this.lastBallSum = choice;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate("last_ball"),
              id: "LBS",
              value: Number(choice) === 1 ? translate("sum_less_than") + "24.5" : translate("sum_more_than")  + "24.5",
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
            });
          }
          this.sendNoOfCombs();
        }
      }
    },
    setFirstFiveSum(choice) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.firstFiveSum !== 0) {
        if (this.firstFiveSum == choice) {
          this.firstFiveSum = 0;
          this.$emit("removeFromSlip", "FVS");
        } else {
          this.$emit("removeFromSlip", "FVS");
          this.firstFiveSum = choice;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('preballs_sum'),
            id: "FVS",
            value: Number(choice) === 1 ? translate("sum_less_than") + "122.5" : translate("sum_more_than")  + "122.5",
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.firstFiveSum == choice) {
            this.firstFiveSum = 0;
            this.$emit("removeFromSlip", "FVS");
          } else {
            this.firstFiveSum = choice;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate("preballs_sum"),
              id: "FVS",
              value: Number(choice) === 1 ? translate("sum_less_than") + "122.5" : translate("sum_more_than")  + "122.5",
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
            });
          }
          this.sendNoOfCombs();
        }
      }
    },
    setFirstBallSum(number) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.firstBallSum !== 0) {
        if (this.firstBallSum == number) {
          this.firstBallSum = 0;
          this.$emit("removeFromSlip", "FBS");
        } else {
          this.$emit("removeFromSlip", "FBS");
          this.firstBallSum = number;
          this.$emit("addToSlip", {
            type: "EXTRAS",
            name: translate('first_ball'),
            id: "FBS",
            value: Number(number) === 1 ? translate("sum_less_than") + "24.5" : translate("sum_more_than")  + "24.5",
            minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
          });
        }
        this.sendNoOfCombs();
      } else {
        if (!this.isSlipFull()) {
          if (this.firstBallSum == number) {
            this.firstBallSum = 0;
            this.$emit("removeFromSlip", "FBS");
          } else {
            this.firstBallSum = number;
            this.$emit("addToSlip", {
              type: "EXTRAS",
              name: translate("first_ball"),
              id: "FBS",
              value: Number(number) === 1 ? translate("sum_less_than") + "24.5" : translate("sum_more_than")  + "24.5",
              minBetVal: 1 * Number(this.getGameConfig.Bingo_MinBetCombination)
            });
          }
          this.sendNoOfCombs();
        }
      }
    },
    setFirstColor(ball) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.firstColors.filter((color) => color.selected).length > 0) {
          this.firstColors.map((loopBall) => {
            if (ball.color == loopBall.color) {
              loopBall.selected = !loopBall.selected;
              if (this.firstColors.filter((color) => color.selected).length > 4) {
                this.$bvToast.toast(
                    translate('choose_1_2_4_first'),
                  {
                    title: translate("notification"),
                    variant: "danger",
                    autoHideDelay: 3000,
                    toaster: "b-toaster-top-center",
                  }
                );
                loopBall.selected = false;
            }
              if (this.firstColors.filter((color) => color.selected).length < 1) {
                this.$emit("removeFromSlip", "FVC");
                this.sendNoOfCombs();
              }
            }
          })
        } else {
          if (!this.isSlipFull()) {
            this.firstColors = this.firstColors.map((loopBall) => {
              if (ball.color == loopBall.color) {
                loopBall.selected = !loopBall.selected;
              }
              return loopBall;
            });
            this.sendNoOfCombs();
            if (this.firstColors.filter((color) => color.selected).length > 4) {
              this.$bvToast.toast(
                translate('choose_1_2_4_first'),
                {
                  title: translate("notification"),
                  variant: "danger",
                  autoHideDelay: 3000,
                  toaster: "b-toaster-top-center",
                }
              );
            }

            if (this.firstColors.filter((color) => color.selected).length < 1) {
              this.$emit("removeFromSlip", "FVC");
            }

            if (this.firstColors.filter((color) => color.selected).length > 0) {
              this.addToSlipFirstBalls();
            }
          }
      }
    },
    setLastColor(ball) {
      if (this.checkAreAlreadyBallsInSlip()) {
        return;
      }
      if (this.lastColors.filter((color) => color.selected).length > 0) {
          this.lastColors.map((loopBall) => {
            if (ball.color == loopBall.color) {
              loopBall.selected = !loopBall.selected;
              if (this.lastColors.filter((color) => color.selected).length > 4) {
                this.$bvToast.toast(
                    translate('choose_1_2_4_last'),
                  {
                    title: translate("notification"),
                    variant: "danger",
                    autoHideDelay: 3000,
                    toaster: "b-toaster-top-center",
                  }
                );
                loopBall.selected = false;
            }
              if (this.lastColors.filter((color) => color.selected).length < 1) {
                this.$emit("removeFromSlip", "LBC");
                this.sendNoOfCombs();
              }
            }
          })
        } else {
          if (!this.isSlipFull()) {
            this.lastColors = this.lastColors.map((loopBall) => {
              if (ball.color == loopBall.color) {
                loopBall.selected = !loopBall.selected;
              }
              return loopBall;
            });
            this.sendNoOfCombs();
            if (this.lastColors.filter((color) => color.selected).length > 4) {
              this.$bvToast.toast(translate('choose_1_2_4_last'), {
                title: translate("notification"),
                variant: "danger",
                autoHideDelay: 3000,
                toaster: "b-toaster-top-center",
              });
            }
            if (this.lastColors.filter((color) => color.selected).length < 1) {
              this.$emit("removeFromSlip", "LBC");
            }

            if (this.lastColors.filter((color) => color.selected).length > 0) {
              this.addToSlipLastBalls();
            }
          }
        }
    },
    color2number(color) {
      return this.colors[color];
    },
    callBuyTicket(payload) {
      this.$emit(
        "buyingTicket",
        Object.assign(
          {
            topColors: this.topColors
              .filter((color) => color.selected)
              .map((ball) => this.color2number(ball.color))
              .sort()
              .join(""),
            firstColors: this.firstColors
              .filter((color) => color.selected)
              .map((ball) => this.color2number(ball.color))
              .sort()
              .join(""),
            lastColors: this.lastColors
              .filter((color) => color.selected)
              .map((ball) => this.color2number(ball.color))
              .sort()
              .join(""),
            ballParity: this.ballParity,
            firstFiveSum: this.firstFiveSum,
            firstBallParity: this.firstBallParity,
            lastBallParity: this.lastBallParity,
            firstBallSum: this.firstBallSum,
            lastBallSum: this.lastBallSum,
          },
          payload
        )
      );
    },
    fillExtraBetBalls() {
      Object.keys(this.colors).forEach((color) => {
        this.topColors.push({
          color: color,
          selected: false,
        });
        this.firstColors.push({
          color: color,
          selected: false,
        });
        this.lastColors.push({
          color: color,
          selected: false,
        });
      });
    },
    setRepeatBets(data) {
      this.clearAllBets();
      // Set Top Colors
      data.topColor.forEach((color) => {
        this.setTopColor({
          color,
        });
      });

      // Set First Colors
      data.firstColor.forEach((color) => {
        this.setFirstColor({
          color,
        });
      });

      // Set last Colors
      data.lastColor.forEach((color) => {
        this.setLastColor({
          color,
        });
      });

      // Set First Five Sum
      this.setFirstFiveSum(data.first5Sum);

      // Set First Ball Sum
      this.setFirstBallSum(data.firstBallSum);

      // Set First Ball Parity
      this.setFirstBallParity(data.firstBallParity);

      // Set Ball Parity
      this.setBallParity(data.ballParity);

      // Set Last Ball Sum
      this.setLastBallSum(data.lastBallSum);

      // Set Last Ball Parity
      this.setLastBallParity(data.lastBallParity);
    },
  },
  mounted() {
    this.fillExtraBetBalls();
    $eventBus.$on("buyLuckyBallsTicket", (payload) => {
      this.callBuyTicket(payload);
    });
    $eventBus.$on("clearAllBets", () => {
      this.clearAllBets();
    }); 
    $eventBus.$on("removeExtrasFromSlip", (item) => {
      if (item) {
        switch (item) {
          case "TC":
            this.topColors = this.topColors.map((loopBall) => {
              loopBall.selected = false;
              this.sendNoOfCombs();
              return loopBall;
            });
            break;
          case "FVC":
            this.firstColors = this.firstColors.map((loopBall) => {
              loopBall.selected = false;
              this.sendNoOfCombs();
              return loopBall;
            });
            break;
          case "LBC":
            this.lastColors = this.lastColors.map((loopBall) => {
              loopBall.selected = false;
              this.sendNoOfCombs();
              return loopBall;
            });
            break;
          case "LBP":
            this.lastBallParity = 0;
            this.sendNoOfCombs();
            break;
          case "FBP":
            this.firstBallParity = 0;
            this.sendNoOfCombs();
            break;
          case "BP":
            this.ballParity = 0;
            this.sendNoOfCombs();
            break; 
          case "LBS":
            this.lastBallSum = 0;
            this.sendNoOfCombs();
            break; 
          case "FVS":
            this.firstFiveSum = 0;
            this.sendNoOfCombs();
            break;   
          case "FBS":
            this.firstBallSum = 0;
            this.sendNoOfCombs();
            break;          
          default:
            break;
        }
      }
    }); 
    $eventBus.$on("setLuckyBallsReplayTicketExtras", (data) => {
      this.setRepeatBets(data);
    });
  },
  beforeDestroy() {
    $eventBus.$off("clearAllBets");
    $eventBus.$off("buyLuckyBallsTicket");
    $eventBus.$off("setLuckyBallsReplayTicketExtras");
    $eventBus.$off("removeExtrasFromSlip");
  },
};
</script>
